import { INSIGHTS } from "constants/action-types";

export const fetchProductSizeInsights = (productIds: string | string[]) => ({
    type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.START,
    payload: {
        productIds,
    },
});
